import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconShowroom(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <path d="M0.5 4.5C0.5 3.94772 0.947715 3.5 1.5 3.5H4.5V7.5H0.5V4.5Z" stroke="currentColor" />
      <path d="M0.5 7.5H4.5V11.5H1.5C0.947715 11.5 0.5 11.0523 0.5 10.5V7.5Z" stroke="currentColor" />
      <path d="M4.5 7.5H8.5V10.5C8.5 11.0523 8.05228 11.5 7.5 11.5H4.5V7.5Z" stroke="currentColor" />
      <path
        d="M4.5 2C4.5 1.17157 5.17157 0.5 6 0.5H10C10.8284 0.5 11.5 1.17157 11.5 2V6C11.5 6.82843 10.8284 7.5 10 7.5H4.5V2Z"
        fill="currentColor"
        stroke="currentColor"
      />
      <path d="M5.66656 3.66665L7.33323 5.33331L10.3332 2.33331" stroke="white" />
    </SVGIcon>
  );
}
